import { Icon, Paragraph } from "@smartsuite/react-ui/lib";
import { GrayColors } from "@smartsuite/types";
import { translateIfPresent } from "../../../../../../../locales/i18n";
import * as S from "./style";

const CONNECTIONS_ADMIN_MESSAGE =
  "Connections are managed by Workspace Administrators.";

export const ConnectionsAdminFooter: React.FC = () => {
  const message = translateIfPresent(
    `caption.${CONNECTIONS_ADMIN_MESSAGE}`,
    CONNECTIONS_ADMIN_MESSAGE,
  );

  return (
    <S.FooterWrap>
      <S.FooterContent>
        <Icon name="info-filled" size="S" color={GrayColors["G-3"]} />
        <Paragraph color="secondary" size="xs">
          {message}
        </Paragraph>
      </S.FooterContent>
    </S.FooterWrap>
  );
};
